import { EnvironmentConfiguration } from "../configuration/environment-configuration.model";
import { TealiumConfiguration } from "../instrumentation/tealium/tealium-config";

export class EnvironmentConfigurationService{

    private _configuration: EnvironmentConfiguration = new EnvironmentConfiguration()

    public get configuration(): EnvironmentConfiguration{
        return this._configuration;
    }

    public initialize(configJsContent:any){
        this._configuration.rootUrl = configJsContent.rootUrl;
        this._configuration.encoreConfiguration.jsUrl = configJsContent.encoreJs_Url;
        this._configuration.encoreConfiguration.isEnabled = configJsContent.encoreJs_isEnabled;
        this._configuration.encoreConfiguration.cssUrl = configJsContent.encoreCss_Url;
        this._configuration.applicationInsightsInstrumentationKey = configJsContent.appInsights_instrumentationKey;
        this._configuration.tealiumConfiguration.isEnabled = configJsContent.tealium_isEnabled;
        this._configuration.tealiumConfiguration.account =configJsContent.tealium_account;
        this._configuration.tealiumConfiguration.profile = configJsContent.tealium_profile;
        this._configuration.tealiumConfiguration.environment = configJsContent.tealium_environment;
        this._configuration.contentApiConfiguration.rootUrl = configJsContent.contentApi_rootUrl;
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/environment-configuration.service.ts